/** csi/comm/Response */
define([
	"dojo/_base/declare"
], function(declare) {

	return declare(null, {
		/** @property {any} data - response from server */
		data: null,

		/** @property {Object} xhrResult - xhr full response object, including headers. See csi/comm/request->_xhr() ( and _xhrRetry() ) for data source. */
		_xhrResult: null,

		/**
		 * @param {any} data - request response
		 * @param {Object} [xhrResult] - xhr full response object
		 */
		constructor: function(data, xhrResult) {
			this.data = data;
			this._xhrResult = xhrResult;
		},
		
		/**
		 * Return error in response; by default there is none
		 * @return {Error}
		 */
		getError: function() {
			return null;
		},

		/**
		 * Return value of response header
		 * @param {sting} headerName
		 * @return {string}
		 */
		getHeader: function(headerName) {
			return this._xhrResult ? this._xhrResult.getHeader(headerName) : "";
		},

		/**
		 * Return time from server if known; by default there is none
		 * @return {number}
		 */
		getTime: function() {
			return 0;
		},


		/**
		 * Return true if non-null response from server
		 * @return {boolean}
		 */
		isValid: function() {
			return this.data != null;
		}
	});
});